<template>
	<form ref="newsletterForm"
		method="POST"
		:id="formId"
		@submit.prevent="handleSubmit"
	>
		<div class="row mx-0">
			<div class="input-container col-12 col-md-6">
				<input
					v-model="firstName"
					type="text"
					required="required"
					:placeholder="$translate('Eros::Template.formFirstnamePlaceholder')"
				/>
			</div>

			<div class="input-container col-12 col-md-6">
				<input
					v-model="lastName"
					type="text"
					required="required"
					:placeholder="$translate('Eros::Template.formLasttnamePlaceholder')"
				/>
			</div>
		</div>

		<div class="row mx-0">
			<div class="input-container col-12 col-md-6">
				<input
					v-model="email"
					@focus="loadRecaptcha = true"
					type="email"
					autocomplete="email"
					required="required"
					:placeholder="$translate('Eros::Template.formEmailPlaceholder')"
				/>
			</div>

			<div class="input-container col-12 col-md-6">
				<button class="newsletter-submit-button" type="submit" :disabled="isDisabled">
					{{ $translate("Eros::Template.submitButtonLabel") }}
				</button>
			</div>

			<label class="form-gdpr">
				<input type="checkbox" required="required" v-model="gdprAccepted" />
				<span v-html="$translate('Eros::Template.gdprLabel', { privacyUrl: privacyUrl })"></span>
			</label>
		</div>
        <recaptcha v-if="!!$ceres.config.global.googleRecaptchaApiKey && loadRecaptcha"></recaptcha>
	</form>
</template>

<script>
import ApiService from "../../../ceres/services/ApiService";
import NotificationService from "../../../ceres/services/NotificationService";
import { executeReCaptcha } from "../../../ceres/helper/executeReCaptcha";

export default {
	props: {
		redirectUrl: {
			type: String,
			required: true,
		},
		listId: {
			type: Number,
			required: true
		},
		templateId: {
			type: Number,
			required: true
		},
		formId: String,
		privacyUrl: String,
	},

	data() {
		return {
			firstName: "",
			lastName: "",
			email: "",
			gdprAccepted: false,
            loadRecaptcha: false,
            isDisabled: false,
		};
	},

	methods: {
		handleSubmit() {
			this.isDisabled = true;

            const recaptchaEl = this.$el.querySelector("[data-recaptcha]");

            if (App.config.global.googleRecaptchaApiKey && (!window.grecaptcha || !recaptchaEl))
            {
                NotificationService.error(this.$translate("Ceres::Template.newsletterAcceptRecaptchaCookie"));
                this.isDisabled = false;
                return;
            }

            executeReCaptcha(this.$el)
            .then(() =>
            {
				ApiService.post("/rest/erosbackend/brevo/signup/", {
					attributes: {
						VORNAME: this.firstName,
						NACHNAME: this.lastName,
						EMAIL: this.email,
						OPT_IN: this.gdprAccepted,
					},
					includeListIds: [this.listId],
					redirectionUrl: this.redirectUrl,
					email: this.email,
					templateId: this.templateId,
				})
				.done(response => {
					if("status" in response) {
						this.resetInputs(); 

						if(response["status"] == "success") {
							NotificationService.success(
								this.$translate("Eros::Template.newsletterSendMessageSuccess")
							).closeAfter(1500);
						}

						if(response["status"] == "error") {
							NotificationService.error(this.$translate("Ceres::Template.newsletterErrorMessage"));
							// if("details" in response)
							// {
							// 	NotificationService.error(TranslationService.translate("Eros::Template." + response.message.toString()).replace("<details>", response.details.toString())).closeAfter(5000);
							// }
							// else
							// {
							// 	NotificationService.error(TranslationService.translate("Eros::Template." + response.message.toString())).closeAfter(5000);
							// }
						}
					}

					this.isDisabled = false;
                    this.resetRecaptcha();
				})
				.fail(err => {
					NotificationService.error(this.$translate("Ceres::Template.newsletterErrorMessage"));
					console.error(err);
					this.isDisabled = false;
					this.resetRecaptcha();
				});
            });
		},

		resetInputs()
		{
			this.firstName = "";
			this.lastName = "";
			this.email = "";
			this.gdprAccepted = false;
		},

		resetRecaptcha()
		{
			if(App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha)
			{
				const recaptchaId = this.$el.querySelector("[data-recaptcha]");

				window.grecaptcha.reset(recaptchaId);
			}
		},
	}
};
</script>
